import ApiService from '../ApiService'

class IntegrationsApiService extends ApiService {

    /**
     * @param {"garmin" | "wahoo" | "huawei"} provider
     */
    async disconnect(provider) {
        this.endpoint.delete({
            params: { provider },
        })
    }

}

export default IntegrationsApiService
